import { Form, Input } from 'antd'
import React, { useMemo } from 'react'
import { profileScreen } from '../../../../translates'
import { validatePassportNumber } from '../../../../helper'
import SberIcon from '../../SberIcon'

const PassportNumberFormItem = ({
  label = profileScreen.input.passportnumber.label,
  rules = undefined,
  requiredRule = true,
  messageRule = profileScreen.input.passportnumber.message,
  size = 'large',
  placeholder = profileScreen.input.passportnumber.placeholder,
  classNameInput = '',
  showCheckIcon = false
}) => {
  const labelParam = useMemo(() => {
    return showCheckIcon
      ? <>{label}<SberIcon style={{ marginLeft: '0.5rem' }} /></>
      : label
  }, [label, showCheckIcon])

  return (
    <Form.Item
      name={['personalData', 'passport', profileScreen.input.passportnumber.name]}
      label={labelParam}
      rules={rules ?? [{ required: requiredRule, message: messageRule, validator: validatePassportNumber }]}
    >
      <Input
        type='number'
        size={size}
        placeholder={placeholder}
        className={classNameInput}
      />
    </Form.Item>
  )
}
export default PassportNumberFormItem
